// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/utils/number-helpers.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/utils/src/number-helpers.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo listto-app
//     node fleet/fleet.ts check --repo listto-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Normalizes database numeric values (number, string, bigint) to a standard number.
 * Helpful for SQLite aggregates which can return varying types or NULL.
 */
export function toNumber(value: number | string | bigint | null | undefined): number {
  if (value === null || value === undefined) {
    return 0;
  }
  return Number(value);
}
const PERCENTAGE_BASE = 100;

/**
 * Calculates a rounded completion percentage.
 */
export function calculateCompletionPercentage(completed: number, total: number): number {
  if (total === 0) {
    return 0;
  }
  return Math.round((completed / total) * PERCENTAGE_BASE);
}
